import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { capitalize } from "lodash";

import { EventService } from "../../../../../../modules/shared/services/event.service";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

@Component({
    selector: "login-config",
    templateUrl: "./login-config.view.html",
    providers: []
})
export class LoginConfigView implements OnInit {
    baseUrl = "";
    expansionStyle = "";
    loginFieldLabel = "";
    headerConfig: any = {};
    bodyConfig: any = {};
    buttonConfig: any = {};
    footerConfig: any = {};
    ssoList: any = {};
    regStatusesList: any = {};
    ssoDropdownSettings: any = {
        singleSelection: false,
        idField: "id",
        textField: "name",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: false,
        isDateSelector: false
    };
    regStatusDropdownSettings: any = {
        singleSelection: false,
        idField: "orderIndex",
        textField: "name",
        selectAllText: "All",
        unSelectAllText: "All",
        allowSearchFilter: true,
        isDateSelector: false,
        searchPlaceholderText: "Enter search term..."
    };

    // Configuration for session-expired popup
    sessionExpiredHeaderConfig: any = {};
    sessionExpiredBodyConfig: any = {};
    sessionExpiredButtonConfig: any = {};

    constructor(
        public sharedService: SharedService,
        public activatedRoute: ActivatedRoute,
        public eventService: EventService
    ) {
        this.expansionStyle = this.sharedService.expansionStyle;
        this.headerConfig = this.sharedService.loginConfig.header;
        this.bodyConfig = this.sharedService.loginConfig.body;
        this.buttonConfig = this.sharedService.loginConfig.footer.button;
        this.footerConfig = this.sharedService.loginConfig.footer;

        // Value assignment for session-expired popup content
        this.sessionExpiredHeaderConfig = this.sharedService.loginConfig?.sessionExpiredConfig?.header;
        this.sessionExpiredBodyConfig = this.sharedService.loginConfig?.sessionExpiredConfig?.body;
        this.sessionExpiredButtonConfig = this.sharedService.loginConfig?.sessionExpiredConfig?.footer.button;


        if(this.bodyConfig.regStatusConfigs) {
            let responseConfig: any = [];
            this.bodyConfig.regStatusConfigs.forEach((savedConfig) => {
                this.sharedService.regStatusesList.data.forEach((element) => {
                    if(savedConfig.id == element.id) {
                        responseConfig.push(savedConfig);
                    }
                });
            });
            this.bodyConfig.regStatusConfigs = responseConfig;
        }

        if(!this.bodyConfig.hasOwnProperty('isFormLogin')) {
            this.bodyConfig.isFormLogin = true;
        }
    }

    ngOnInit() {
        if(!('isForgotPasswordEnabled' in this.footerConfig)) {
            this.footerConfig.isForgotPasswordEnabled = false;
        }
        this.ssoList = this.sharedService.ssoList;
        this.regStatusesList = this.sharedService.regStatusesList;
        this.bodyConfig.loginOption = this.bodyConfig.loginOption || "username";
        this.buildLoginFieldLabel(this.bodyConfig.loginOption, this.bodyConfig.loginOption);
    }

    loginOptionChange($event) {
        this.buildLoginFieldLabel(this.bodyConfig.loginOption, $event.value);
        this.bodyConfig.loginOption = $event.value;
    }

    buildLoginFieldLabel(prevOption: string, newOption: string) {
        const prevOptionLabel = capitalize(prevOption);
        const newOptionLabel = capitalize(newOption);
        this.loginFieldLabel = newOptionLabel + " Field Label";

        if (this.bodyConfig.username !== newOptionLabel && this.bodyConfig.username === prevOptionLabel) {
            this.bodyConfig.username = newOptionLabel;
        }
    }
}
